import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button, LoadMore, MediaBox } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import OrderService from 'services/order';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Download from 'components/download.js';
import Http from 'services/http2';
import Big from 'big.js';
import ScheduleService from 'services/schedule';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link } from 'react-router-dom';

function PlanScheduleVendorDetail(props) {
  const Config = {
    purchase: {
      title: '供应商交货排程详情',
      apiPath: '/schedule/detailHeader',
      publishApiPath: '/schedule/import/publish',
      customerNameKey: 'companyName',
      companyCodeKey: 'companyCode',
      vendorNameKey: 'innerVendorName',
      arrEnumField: [
        {
          mainKey: 'B02_Sch_Order_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'billNo',
      detailParams: {
        callerType: 1, //采购方
        detailType: 2
      }
    }
  };

  const config = Config[props.type];

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);

  const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [list, setList] = useState([]);
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [unConfirmVendors, setUnConfirmVendors] = useState([]); //差异待确认供应商列表

  //处理详情数据
  self.afterGetDetail = function (data) {
    getList();
    setDetail(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  function getList() {
    let postbody = {
      billNo: self.id,
      detailType: 2,
      callerType: 1, //采购方
      pageSize: 100,
      pageNum: 1,
      companyCode: companyCode,
      apiPath: '/schedule/detailList'
    };
    if (!self.isPurchase) {
      postbody.callerType = 2;
      postbody.detailType = 2;
      postbody.validStatus = 1;
    }

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let lists = response.data.content || [];
        lists.forEach(item => {
          EnumService.getValue('B02_Sch_Order_Item_Status', item.status).then(
            value => {
              item.statusName = value;
            }
          );
          // 排程数据处理
          let obj = {};
          let prodPlanTotal = 0;
          let estimateStockQty = Big(item.stockQty || 0); //预计库存

          item.detailList.forEach(row => {
            let nPlus, nMinus;
            if (detail.version === 2) {
              //生产计划
              prodPlanTotal += row.prodPlanQty || 0; //计算生产计划总量
              nMinus = row.prodPlanQty || 0;
            } else {
              nMinus = row.scheduleQty;
            }
            if (
              (self.isPurchase && [0, 1, 2].includes(item.status)) ||
              (!self.isPurchase && [0, 1].includes(item.status))
            ) {
              //采购方：未答交；供应商：未答交
              nPlus = row.scheduleQty;
            } else {
              nPlus = row.replyQty;
            }
            estimateStockQty = estimateStockQty.plus(nPlus).minus(nMinus);
            row.estimateStockQty = parseFloat(estimateStockQty.toString());
            obj[row.scheduleDate] = row;
          });
          item.prodPlanQty = prodPlanTotal;
          item.estimateStockQty = parseFloat(estimateStockQty.toString());
          item.objItemList = obj;

          //销售方
          item.isConfirmFlag = item.confirmFlag === 1;
        });
        setList(lists);
      }
    });
  }

  //差异排程确认
  function handleConfirm() {
    let scheduleNo = self.id;
    ScheduleService.confirmSchedule(
      companyCode,
      [scheduleNo],
      detail.vendorCode,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  // 差异排程退回
  function handleReject() {
    let scheduleNo = self.id;
    ScheduleService.rejectScheduleReply(
      companyCode,
      scheduleNo,
      () => {
        dispatch({ type: 'hideReject' });
        self.getDetail();
      },
      dispatch
    );
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">供应商：</label>
              <div className="order-detail-value">{detail.innerVendorName}</div>
            </li>
            <li>
              <label className="order-detail-label">计划编号</label>
              <div className="order-detail-value">{detail.batchNo}</div>
            </li>
            <li>
              <label className="order-detail-label">业务员</label>
              <div className="order-detail-value">{detail.salesman}</div>
            </li>
            <li>
              <label className="order-detail-label">发布时间</label>
              <div>{formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}</div>
            </li>
            <li>
              <label className="order-detail-label">发布人</label>
              <div className="order-detail-value">
                {detail.createEmployeeName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">计划区间</label>
              <div className="order-detail-value">
                {formatDate(detail.schStartDate, 'YYYY-MM-DD')} -
                {formatDate(detail.schEndDate, 'YYYY-MM-DD')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">计划说明</label>
              <div className="order-detail-value">{detail.schDesc}</div>
            </li>

            <li>
              <label className="order-detail-label">状态</label>
              <div
                className={
                  [1].indexOf(detail.status) > -1
                    ? 'order-detail-value orange'
                    : [3].indexOf(detail.status) > -1
                    ? 'order-detail-value red'
                    : 'order-detail-value green'
                }
              >
                {detail.statusName}
              </div>
            </li>
            {detail.status === 6 && detail.returnDesc && (
              <li>
                <label className="order-detail-label">退回原因</label>
                <div className="order-detail-value">{detail.returnDesc}</div>
              </li>
            )}
          </ul>
        </div>

        {/*排程明细 */}
        {!Util.isEmpty(list) && (
          <div className="order-detail-box">
            <div className="order-detail-block">
              <div
                className={
                  !boxState[1]
                    ? 'order-detail-title m-more'
                    : 'order-detail-title m-more m-more-open'
                }
              >
                <label>排程明细</label>
                <i className="icon-down" onClick={() => handleBoxState(1)}></i>
              </div>
              {boxState[1] && (
                <div className="order-detail-list">
                  <ul>
                    {list.map((item, index) => (
                      <li className="order-detail-item" key={index}>
                        <span className="lineNo">项次 {index + 1}</span>
                        <ul className="clearfix">
                          <li>
                            产品编码：
                            {item.prodCode}
                          </li>
                          <li>
                            产品名称：
                            {item.prodName}
                          </li>
                          <li className="single">
                            产品规格（特征值）：
                            <span>
                              {item.prodScale} {item.prodFeature}
                            </span>
                          </li>
                          <li>
                            确认说明：
                            {item.confirmDesc}
                          </li>
                          <li>
                            供应商：
                            {item.innerVendorName}
                          </li>
                          <li>
                            利润中心：
                            {item.profitCenterCode}/{item.profitCenterName}
                          </li>
                          <li>
                            采购单号：
                            {item.poErpNoShow}
                          </li>
                          <li>
                            备注：
                            {item.remark}
                          </li>
                          <li>
                            订单待出：
                            {formatNumber(
                              item.waitDeliveryQty,
                              decimalPlace.QTY
                            )}
                          </li>

                          <li>
                            库存数量：
                            {formatNumber(item.stockQty, decimalPlace.QTY)}
                          </li>

                          <li>
                            单据状态：
                            {item.statusName}
                          </li>
                          <li>
                            差异原因：
                            {item.diffDesc}
                          </li>
                          <li>
                            生产计划：
                            {detail.version === 2
                              ? formatNumber(item.prodPlanQty, decimalPlace.QTY)
                              : ''}
                          </li>
                          <li>
                            排程数量：
                            {formatNumber(
                              item.scheduleTotalQty,
                              decimalPlace.QTY
                            )}
                          </li>
                          {self.isPurchase && (
                            <li>
                              确认数量：
                              {[0, 1, 2].indexOf(item.status) === -1 &&
                              item.replyTotalQty
                                ? formatNumber(
                                    item.replyTotalQty,
                                    decimalPlace.QTY
                                  )
                                : ''}
                            </li>
                          )}
                          {!self.isPurchase && (
                            <li>
                              确认数量：
                              {item.status !== 1 && item.replyTotalQty
                                ? formatNumber(
                                    item.replyTotalQty,
                                    decimalPlace.QTY
                                  )
                                : formatNumber(
                                    item.scheduleTotalQty,
                                    decimalPlace.QTY
                                  )}
                            </li>
                          )}
                          <li>
                            预计库存：
                            {formatNumber(
                              item.estimateStockQty,
                              decimalPlace.QTY
                            )}
                          </li>
                        </ul>
                        <div className="order-detail-more">
                          {self.isPurchase &&
                            item.detailList &&
                            item.detailList.map((row, i) => (
                              <ul key={i + 1}>
                                <li className="single">
                                  日期：
                                  {formatDate(row.scheduleDate, 'YYYY-MM-DD')}
                                </li>
                                <li>
                                  生产计划：
                                  {detail.version === 2
                                    ? formatNumber(
                                        row.prodPlanQty,
                                        decimalPlace.QTY
                                      )
                                    : ''}
                                </li>
                                <li>
                                  排程数量：
                                  {formatNumber(
                                    row.scheduleQty,
                                    decimalPlace.QTY
                                  )}
                                </li>
                                <li>
                                  确认数量：
                                  {[0, 1, 2].indexOf(item.status) === -1
                                    ? formatNumber(
                                        row.scheduleQty,
                                        decimalPlace.QTY
                                      )
                                    : ''}
                                </li>
                                <li>
                                  预计库存：
                                  {detail.version === 2
                                    ? formatNumber(
                                        row.estimateStockQty,
                                        decimalPlace.QTY
                                      )
                                    : ''}
                                </li>
                              </ul>
                            ))}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10020203') && [3, 7].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleConfirm();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认
            </Button>
          )}

          {User.checkAuth('10020203') && [3, 7].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handleReject();
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              退回
            </Button>
          )}
        </div>
      )}
      <Modal></Modal>
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
    </div>
  );
}

PlanScheduleVendorDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanScheduleVendorDetail);
